import { request as _request } from "pwapi/core/request";

import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";
import { useAppSelector } from "store/hooks";

const QuickAuditLogButton = () => {
  const _case = useAppSelector(({ admin }) => admin.case);
  const canUseAuditLog = useAppSelector((state) =>
    selectFeatureFlag(state, "canUseAuditLog")
  );

  const handleClick = async () => {
    try {
      if (!_case?.id) {
        throw new Error("No case ID was found, cannot fetch audit log");
      }
      const response = await _request({
        method: "GET",
        path: `/api/v2/audit/${_case?.id}`,
      });

      const responseBlob = window.URL.createObjectURL(response.body);
      if (responseBlob) {
        window.open(responseBlob);
      }
    } catch (e) {
      console.error("Error fetching audit log:", e);
    }
  };

  return canUseAuditLog ? (
    <PathologyWatchButton onClick={handleClick}>Audit Log</PathologyWatchButton>
  ) : null;
};

export default QuickAuditLogButton;
